import React, { useEffect, useState, useRef } from "react";
import toast from "react-hot-toast";
import { Modal, Form, Input, Button, Divider } from "antd";
import { EnvironmentOutlined, SaveOutlined } from "@ant-design/icons";
import AddImage from "../../Global Functions/addImage";
import "./addUpdateComingSoonCities.css";

const CommingSoonCityEditModal = ({
    visible,
    onClose,
    cityData,
    onSave,
    settingsId,
}) => {
    const [form] = Form.useForm();
    const [imagePreview, setImagePreview] = useState(null);
    const imageInputRef = useRef(null);

    useEffect(() => {
        if (visible && cityData) {
            form.setFieldsValue(cityData);
            setImagePreview(cityData.url);
        } else if (visible) {
            form.resetFields();
            setImagePreview(null);
        }
    }, [visible, cityData, form]);

    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const validTypes = ["image/png", "image/jpeg", "image/jpg"];
        if (!validTypes.includes(file.type)) {
            toast.error("Please upload an image in PNG, JPEG, or JPG format only.");
            event.target.value = "";
            return;
        }

        try {
            const uploadedUrl = await AddImage(file);
            if (uploadedUrl) {
                form.setFieldsValue({ url: uploadedUrl });
                setImagePreview(uploadedUrl);
            }
        } catch {
            toast.error("Image upload failed");
        }
    };

    const handleFinish = (values) => {
        onSave(values);
    };

    return (
        <Modal
            title={
                <div className="city-edit-modal-header-content">
                    <EnvironmentOutlined className="city-edit-modal-header-icon" style={{ color: "white" }} />
                    <span style={{ color: "white" }}>
                        {cityData?._id ? "EDIT CITY" : "ADD CITY"}
                    </span>
                </div>
            }
            open={visible}
            onCancel={onClose}
            footer={null}
            destroyOnClose
            width={600}
            className="city-edit-modal-override"
            styles={{
                header: {
                    background: "#0D152B",
                    borderRadius: "12px 12px 0 0",
                    padding: "20px 24px",
                    borderBottom: "none",
                },
                body: {
                    padding: "24px",
                    background: "#fafafa",
                },
            }}
        >
            <div className="city-edit-modal-form">
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleFinish}
                >
                    <div className="city-edit-section">
                        <h3 className="city-edit-section-header">City Information</h3>
                        <div className="city-edit-grid">
                            <Form.Item
                                label="City Name"
                                name="name"
                                rules={[{ required: true, message: "Please input city name" }]}
                            >
                                <Input
                                    size="large"
                                    placeholder="Enter city name"
                                    className="city-edit-input-override"
                                />
                            </Form.Item>

                            <Form.Item
                                label={
                                    <span>
                                        City Image <span style={{ color: 'red' }}>*</span>
                                    </span>
                                }
                                name="url"
                                rules={[{ required: true, message: "Image is required." }]}
                            >
                                <div className="city-image-upload-wrapper">
                                    <div
                                        className="city-image-upload-box"
                                        onClick={() => imageInputRef.current.click()}
                                    >
                                        <input
                                            type="file"
                                            accept="image/png, image/jpeg, image/jpg"
                                            ref={imageInputRef}
                                            onChange={handleFileChange}
                                            style={{ display: 'none' }}
                                        />

                                        {imagePreview ? (
                                            <div className="city-image-preview-container">
                                                <img
                                                    src={imagePreview}
                                                    alt="City Preview"
                                                    className="city-image-preview"
                                                />
                                                <div className="city-image-overlay">
                                                    <EnvironmentOutlined style={{ fontSize: '24px', color: 'white' }} />
                                                    <span>Click to change image</span>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="city-image-placeholder">
                                                <EnvironmentOutlined style={{ fontSize: '48px', color: '#0D152B', marginBottom: '12px' }} />
                                                <span className="upload-text">Upload City Image</span>
                                                <span className="upload-subtext">PNG, JPG or JPEG (Max 5MB)</span>
                                                <Button
                                                    type="primary"
                                                    style={{
                                                        marginTop: '16px',
                                                        background: '#0D152B',
                                                        borderColor: '#0D152B'
                                                    }}
                                                >
                                                    Browse Files
                                                </Button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </Form.Item>
                        </div>

                        <Form.Item
                            label="Description"
                            name="description"
                            rules={[{ required: true, message: "Please input description" }]}
                        >
                            <Input.TextArea
                                rows={3}
                                placeholder="Enter city description"
                                className="city-edit-input-override"
                                maxLength={500}
                            />
                        </Form.Item>
                    </div>

                    <Divider className="city-edit-divider" />

                    <Form.Item style={{ marginBottom: 0 }}>
                        <div className="city-edit-actions">
                            <Button
                                size="large"
                                onClick={onClose}
                                className="city-edit-btn city-edit-btn-cancel"
                            >
                                Cancel
                            </Button>
                            <Button
                                htmlType="submit"
                                size="large"
                                icon={<SaveOutlined style={{ color: "white"}}/>}
                                className="city-edit-btn city-edit-btn-primary city-edit-btn-override"
                            >
                                <span style={{ color: "white" }}>
                                    {cityData?._id ? "Update City" : "Add City"}
                                </span>
                            </Button>
                        </div>
                    </Form.Item>
                </Form>
            </div>
        </Modal>
    );
};

export default CommingSoonCityEditModal;
